import "./AboutProject.css";
import { Link } from 'react-router-dom';
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import GrainOverlay from '../GrainOverlay';

const AboutProject = ({ title, description, imageUrl, redirectUrl, odd, year }) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: "-100px" });

    return (
        <motion.section
            ref={ref}
            className={`AboutProject ${odd ? 'odd' : 'even'} grain-light`}
        >
            <GrainOverlay intensity={0.12} />
            <div className="project-card-inner">
                <motion.div
                    className="project-card-image"
                    initial={{ opacity: 0, x: odd ? 60 : -60 }}
                    animate={isInView ? { opacity: 1, x: 0 } : {}}
                    transition={{ type: 'spring', stiffness: 80, damping: 20 }}
                >
                    <Link to={`/${redirectUrl}`} className="image-link">
                        <img src={imageUrl} alt={title} />
                    </Link>
                </motion.div>

                <motion.div
                    className="project-card-text"
                    initial={{ opacity: 0, y: 30 }}
                    animate={isInView ? { opacity: 1, y: 0 } : {}}
                    transition={{ type: 'spring', stiffness: 80, damping: 20, delay: 0.15 }}
                >
                    {year && <span className="project-year">{year}</span>}
                    <h2 className="project-card-title">{title}</h2>
                    <p className="project-card-desc">{description}</p>
                    <Link to={`/${redirectUrl}`} className="project-card-link">
                        View Case Study
                        <span className="link-arrow">&rarr;</span>
                    </Link>
                </motion.div>
            </div>
        </motion.section>
    );
};

export default AboutProject;
